import { ExternalLink, Stethoscope } from 'lucide-react';

const doctorUrl = new URL(process.env.REACT_APP_DOCTOR_PORTAL_URL);
if (doctorUrl.protocol !== 'https:') throw new Error('Doctor portal URL must use HTTPS');

export const PortalDoctorLink = ({ mobile = false, onClick }) => (
  <a href={doctorUrl.href} target="_blank" rel="noopener noreferrer" referrerPolicy="no-referrer"
    onClick={onClick} data-testid={mobile ? 'portal-more-doctor' : 'portal-nav-doctor'}
    aria-label="Talk to a Doctor — AllRound Health, opens in a new tab"
    title="AllRound Health — opens in a new tab"
    className={mobile ? 'portal-more-row' : 'flex items-center gap-2 px-3 py-2 rounded-xl text-sm whitespace-nowrap text-slate-600 hover:bg-emerald-100 transition-colors'}>
    <Stethoscope size={mobile ? 20 : 16} aria-hidden="true" />
    <span className={mobile ? 'portal-row-label' : undefined}>Talk to a Doctor</span>
    <ExternalLink size={mobile ? 17 : 14} aria-hidden="true" />
  </a>
);